var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"contact-us-btn",on:{"click":_vm.toPricingInfo}},[_c('i',{staticClass:"el-icon-phone-outline"})])])}
var staticRenderFns = []

export { render, staticRenderFns }